import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { BrowserRouter, Redirect, Route, Switch, withRouter } from 'react-router-dom';

import AdvertisementScreen from 'Advertisement/AdvertisementScreen'
import SubmitScreen from 'Submit/SubmitScreen'
import MypageScreen from 'Mypage/MypageScreen'
// import AdminLoginScreen from 'Admin/AdminLogin'
import QnaListScreen from 'QnA/QnaListScreen'
import QnaReadScreen from 'QnA/QnaReadScreen'
import QnaPostScreen from 'QnA/QnaPostScreen'
import AdminScreen from 'Admin/AdminScreen'


class Routes extends Component {
    componentDidMount() {

    }

    componentWillUnmount() {

    }

    render(){
        return (
            <BrowserRouter>
                <Switch>
                    <Route path="/" exact component={AdvertisementScreen} />
                    <Route path="/sub/:code" exact component={SubmitScreen} />
                    <Route path="/mypage" exact component={MypageScreen} />
                    <Route path="/admin" exact component={AdminScreen} />
                    {/* <Route path="/admin" exact component={AdminLoginScreen} /> */}
                    <Route path="/qna" exact component={QnaListScreen} />
                    <Route path="/qna/new" exact component={QnaPostScreen} />
                    <Route path="/qna/:index" exact component={QnaReadScreen} />
                    <Route path="/qna/:index/edit" exact component={QnaPostScreen} />
                    
                    <Route path='*' component={AdvertisementScreen} />
                </Switch>
            </BrowserRouter>
        );
    }
}

let mapStateToProps = (state) => ({

});

let mapDispatchToProps = (dispatch) => ({

});

export const RoutesApp = connect(mapStateToProps, mapDispatchToProps)(Routes);
